import { render, staticRenderFns } from "./AppScore.vue?vue&type=template&id=253a8103"
import script from "./AppScore.vue?vue&type=script&lang=js"
export * from "./AppScore.vue?vue&type=script&lang=js"
import style0 from "./AppScore.vue?vue&type=style&index=0&id=253a8103&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports